import { render, staticRenderFns } from "./Home2026.vue?vue&type=template&id=074970bc"
import script from "./Home2026.vue?vue&type=script&lang=js"
export * from "./Home2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports